import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62ae68b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "screen-reader-only" }, "Planfree.dev game lobby", -1))
const _hoisted_2 = {
  key: 1,
  class: "home"
}
const _hoisted_3 = { class: "top-buttons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z" })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Invite players", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "button invite copied no-hover"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Copied to clipboard", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "top-left-buttons" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20",
  width: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7.333 14.896 10 13.312l2.688 1.584-.709-3 2.313-1.979-3.063-.271L10 6.792 8.771 9.646l-3.063.271 2.334 1.979ZM5.062 18l1.313-5.542L2 8.729l5.75-.5L10 3l2.25 5.25 5.75.479-4.375 3.729L14.938 18 10 15.062ZM10 11.062Z" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20",
  width: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7 17v-2H3.5q-.625 0-1.062-.438Q2 14.125 2 13.5v-9q0-.625.438-1.062Q2.875 3 3.5 3H11v1.5H3.5v9h13V11H18v2.5q0 .625-.438 1.062Q17.125 15 16.5 15H13v2Zm7.479-6L11 7.521l1.062-1.063 1.688 1.688V3h1.5v5.104l1.688-1.687L18 7.479Z" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "button no-hover"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cast your votes", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show votes!", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Start new game!", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 3,
  class: "button no-hover"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "name" }
const _hoisted_27 = {
  key: 4,
  class: "options"
}
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = {
  key: 5,
  class: "results-container"
}
const _hoisted_30 = { class: "results" }
const _hoisted_31 = { class: "average" }
const _hoisted_32 = { class: "popular" }

import store from "@/store";
import Modal from "@/components/Modal.vue";
import Player from "@/view-models/player";
import { io } from "socket.io-client";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  name: 'Game',
  setup(__props) {

let showInstallPwa = ref(false);
const modal = ref(true);
const showVotes = ref(false);
const showCopiedToClipboard = ref(false);
const countdown = ref(0);
const interval: any = ref(null);
const name = ref("");
const currentVote: any = ref(null);


let deferredPrompt: any;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  showInstallPwa.value = true;
});

function installPWA() {
  deferredPrompt.prompt();
}


onMounted(() => {
  if (joiningAGame()) {
    const route = useRoute();
    const socket = io(process.env.VUE_APP_SERVER, {
      query: {
        roomId: route.params.id,
      },
    });
    store.commit("setSocket", socket);
  }

  const storedName = localStorage.getItem("name");
  if (storedName) {
    enteredName(storedName);
  }

  setupSocketHandlers();
});

function showVotesClicked() {
  store.state.socket.emit("show");
}

function getPlayers() {
  return store.state.players;
}

function performVote(vote: string) {
  store.state.socket.emit("vote", vote);
  currentVote.value = vote;
}

function startNewGame() {
  store.state.socket.emit("restart");
}

function emitName(name: string) {
  store.state.socket.emit("name", name);
}

function enteredName(updatedName: string) {
  name.value = updatedName;
  emitName(updatedName);
  localStorage.setItem("name", updatedName);
  modal.value = false;
}

function playerHasVoted() {
  const players = store.state.players;
  return (
    players.filter((p) => p.vote !== null && p.vote !== undefined).length > 0
  );
}

function copyToClipboard() {
  const tempInput = document.createElement("input");
  tempInput.value = window.location.href;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  showCopiedToClipboard.value = true;
  setTimeout(() => (showCopiedToClipboard.value = false), 3000);
}

function getAverage() {
  const players = store.state.players;
  let count = 0;
  let total = 0;
  for (const player of players) {
    if (player.vote && player.vote !== "?") {
      total += parseInt(player.vote);
      count++;
    }
  }
  return (total / count).toFixed(1).replace(/\.0+$/, "");
}

function getMode(): string {
  const players = store.state.players;
  const scores: Record<string, number> = {};
  for (const player of players) {
    if (player.vote) {
      if (scores[player.vote]) {
        scores[player.vote] = scores[player.vote] + 1;
      } else {
        scores[player.vote] = 1;
      }
    }
  }

  let mostSeen = 1;
  let mostSeenCard = "";
  for (const key in scores) {
    const value = scores[key];
    if (value > mostSeen) {
      mostSeen = value;
      mostSeenCard = key;
    }
  }

  if (mostSeen == 1) {
    return "NA";
  } else {
    return mostSeenCard;
  }
}

function goToGithub() {
  open("https://github.com/LukeGarrigan/planfree.dev");
}

function joiningAGame() {
  const currentState = store.state.socket;
  return (
    currentState &&
    Object.keys(currentState).length === 0 &&
    currentState.constructor === Object
  );
}

function setupSocketHandlers() {
  store.state.socket.on("update", (players: Player[]) => {
    store.state.players = players;
  });

  store.state.socket.on("show", () => {
    showVotes.value = true;
    clearInterval(interval.value);
    countdown.value = 3;
    interval.value = setInterval(() => {
      countdown.value -= 1;
      if (countdown.value == 0) {
        clearInterval(interval.value);
      }
    }, 1000);
  });

  store.state.socket.on("restart", () => {
    showVotes.value = false;
    currentVote.value = null;
  });

  store.state.socket.on("ping", () => {
    store.state.socket.emit("pong");
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (modal.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          title: "Choose your display name",
          onCompleted: enteredName
        }))
      : _createCommentVNode("", true),
    (!modal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "edit-name-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (modal.value = true))
            }, [
              _createElementVNode("div", null, _toDisplayString(name.value), 1),
              _hoisted_4
            ]),
            (!showCopiedToClipboard.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button invite",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard()))
                }, _hoisted_7))
              : _createCommentVNode("", true),
            (!modal.value && showCopiedToClipboard.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_8, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "star-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToGithub())),
              "aria-label": "Go to the GitHub repository"
            }, _hoisted_14),
            (_unref(showInstallPwa))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "star-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (installPWA())),
                  "aria-label": "Add to homescreen"
                }, _hoisted_16))
              : _createCommentVNode("", true)
          ]),
          (!playerHasVoted() && !showVotes.value)
            ? (_openBlock(), _createElementBlock("button", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (playerHasVoted() && !showVotes.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showVotesClicked()))
              }, _hoisted_21))
            : _createCommentVNode("", true),
          (showVotes.value && countdown.value === 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "button start",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (startNewGame()))
              }, _hoisted_23))
            : _createCommentVNode("", true),
          (showVotes.value && countdown.value > 0)
            ? (_openBlock(), _createElementBlock("button", _hoisted_24, [
                _createElementVNode("span", null, _toDisplayString(countdown.value), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPlayers(), (player) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "players",
              key: player.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["player", { voted: player.vote }])
              }, [
                (showVotes.value && countdown.value === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(player.vote), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", null, _toDisplayString(player.name), 1)
              ])
            ]))
          }), 128)),
          (!showVotes.value || (showVotes.value && countdown.value !== 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            '0',
            '1',
            '2',
            '3',
            '5',
            '8',
            '13',
            '21',
            '34',
            '55',
            '89',
            '?',
          ], (vote) => {
                  return _createElementVNode("button", {
                    key: `vote-${vote}`,
                    class: _normalizeClass(["fib-button", { current: currentVote.value === vote }]),
                    onClick: ($event: any) => (performVote(vote)),
                    disabled: currentVote.value === vote
                  }, [
                    _createElementVNode("span", null, _toDisplayString(vote), 1)
                  ], 10, _hoisted_28)
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (showVotes.value && countdown.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, "Average: " + _toDisplayString(getAverage()), 1),
                  _createElementVNode("div", _hoisted_32, "Popular: " + _toDisplayString(getMode()), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})